import React, { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Send } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { ProductCard } from "../components/ProductCard";

export default function Assistant() {
  const [message, setMessage] = useState("");
  const [reply, setReply] = useState("");
  const [products, setProducts] = useState([]);
  const [busy, setBusy] = useState(false);
  const ask = async () => {
    if (!message.trim()) return;
    setBusy(true); setReply("");
    try {
      const r = await api("/assistant", { method: "POST", body: JSON.stringify({ message: message.trim() }) });
      setReply(r.reply || ""); setProducts(r.products || []);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="المساعد الذكي" />
      <div className="flex items-center gap-2">
        <input data-testid="assistant-input" value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ask()} placeholder="مثال: أبحث عن هدية بأقل من 100 د.ل" className="flex-1 bg-white rounded-2xl px-4 py-3 border border-[#E8EAF2] outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
        <button data-testid="assistant-send" disabled={busy} onClick={ask} className="w-12 h-12 rounded-2xl bg-[#FF3D5A] text-white flex items-center justify-center disabled:opacity-60"><Send size={20} /></button>
      </div>
      {busy && <p className="text-center text-[#6B7280] mt-6">جارٍ التفكير...</p>}
      {reply && (
        <div className="mt-5 p-4 bg-[#FFE5EA] rounded-2xl flex gap-3">
          <Sparkles size={20} className="text-[#FF3D5A] shrink-0 mt-0.5" />
          <p className="text-[#161629] leading-7 whitespace-pre-wrap">{reply}</p>
        </div>
      )}
      {products.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-5">{products.map((p) => <ProductCard key={p.product_id} item={p} />)}</div>
      )}
    </div>
  );
}
